// import package
import React, { Component, Fragment } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import { jsPDF } from "jspdf";
import moment from "moment";

// import component
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import TradeBotModal from "../partials/TradeBot/TradeBotModal";
import ViewTradeBot from "../partials/TradeBot/ViewTradeBot";
import BotUserModal from "../partials/TradeBot/BotUserModal";

// import action
import { getPairDropdown } from "../../actions/commonActions";
import {
    botList,
    removeBot,
    changeBotStatus,
    botOrderCancel,
} from "../../actions/tradingBot";

// import lib
import { toastAlert } from "../../lib/toastAlert";
import { dateTimeFormat } from "../../lib/dateTimeHelper";
import { firstLetterCase } from "../../lib/capitalize";

class TradingBot extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                key: "pair",
                text: "Pair",
                className: "firstCurrencySymbol",
                align: "left",
                sortable: true,
            },
            {
                key: "createdAt",
                text: "Created At",
                className: "secondCurrencySymbol",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return moment(record.createdAt).format("DD-MM-YYYY HH:mm");
                },
            },
            {
                key: "status",
                text: "Status",
                className: "status",
                align: "left",
                sortable: true,
                cell: (record) => {
                    return (
                        <Fragment>
                            <button
                                data-toggle="modal"
                                data-target="#update-spot-modal"
                                className="btn btn-primary btn-sm"
                                onClick={() => this.changeStatus(record._id)}
                                style={{ marginRight: "5px" }}
                            >
                                {firstLetterCase(record.status)}
                            </button>
                        </Fragment>
                    );
                },
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                align: "left",
                sortable: false,
                cell: (record) => {
                    return (
                        <Fragment>
                            <button
                                data-toggle="modal"
                                data-target="#update-spot-modal"
                                title="view"
                                className="btn btn-primary btn-sm"
                                onClick={() => this.openViewBotModal(record)}
                                style={{ marginRight: "5px" }}
                            >
                                <i className="fa fa-eye"></i>
                            </button>
                            <button
                                className="btn btn-primary btn-sm"
                                title="Delete"
                                onClick={() => this.removeRecord(record._id)}
                                style={{ marginRight: "5px" }}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                            <button
                                className="btn btn-primary btn-sm"
                                title="Cancel orders"
                                onClick={() => this.cancelOrder(record._id)}
                                style={{ marginRight: "5px" }}
                            >
                                <i className="fa fa-close"></i>
                            </button>
                        </Fragment>
                    );
                },
            },
        ];

        this.state = {
            records: [],
            totalCount: 0,
            offset: 0,
            pageSize: 10,
            sortOrder: {
                column: "_id",
                order: "desc",
            },
            loading: true,
            exportType: "current",
            extraButtons: [
                {
                    className: "btn btn-primary buttons-pdf",
                    title: "Export PDF",
                    children: [
                        <span>
                            <i
                                className="glyphicon glyphicon-print fa fa-file-pdf-o"
                                aria-hidden="true"
                            ></i>
                        </span>,
                    ],
                    onClick: (event) => {
                        this.exportPDF();
                    },
                },
                {
                    className: "btn btn-primary buttons-csv",
                    title: "Export CSV",
                    children: [
                        <span>
                            <i
                                className="glyphicon glyphicon-print fa fa-file-excel-o"
                                aria-hidden="true"
                            ></i>
                        </span>,
                    ],
                    onClick: (event) => {
                        this.exportCSV();
                    },
                },
            ],
            tradeBotModal: false,
            viewBotModal: false,
            botUserModal: false,
            pairList: [],
            viewRecord: {},
        };

        this.config = {
            page_size: this.state.limit,
            sort: this.state.sortOrder,
            length_menu: [10, 20, 50],
            no_data_text: "No bot found!",
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last",
                },
            },
            key_column: "_id",
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            pagination: 'advance',
            show_info: true,
            button: {
                extra: true,
            }
        };

        this.fetchSpotPair = this.fetchSpotPair.bind(this);
        this.openBotModal = this.openBotModal.bind(this);
        this.closeBotModal = this.closeBotModal.bind(this);
        this.openViewBotModal = this.openViewBotModal.bind(this);
        this.closeViewBotModal = this.closeViewBotModal.bind(this);
        this.getData = this.getData.bind(this);
        this.openBotUrsModal = this.openBotUrsModal.bind(this);
        this.closeBotUrsModal = this.closeBotUrsModal.bind(this);
    }

    componentDidMount() {
        this.fetchSpotPair();
        this.getData();
    }

    async fetchSpotPair() {
        try {
            const { status, loading, result } = await getPairDropdown();
            if (status == "success") {
                this.setState({ pairList: result });
            }
        } catch (err) {}
    }

    getData = async (filter = "") => {
        try {
            let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let data = {
                timezone,
                sortOrder:this.state.sortOrder,
                filter,
                limit: this.state.pageSize,
                offset: this.state.offset,
            };
            let { status, totalCount, result } = await botList(data);
            if (status) {
                this.setState({ loading: false });
                this.setState({ records: result, totalCount });
            }
        } catch (e) {}
    }

    search = data => {
        let filter = data.filter_value;
        let pageSize = data.page_size;
        let offset = (data.page_number-1)*pageSize;
        let sortOrder = data.sort_order ? data.sort_order:this.state.sortOrder;
        this.setState({ records: [], offset, pageSize, sortOrder, filter, loading: true }, function() {
            this.getData(filter);
        });  
    }

    async removeRecord(id) {
        try {
            if (!window.confirm("Are you sure you want to delete?")) {
                return;
            }

            const { status, loading, message } = await removeBot(id);
            if (status == "success") {
                toastAlert("success", message, "removeRecord");
                this.getData();
            } else {
                toastAlert("error", message, "removeRecord");
            }
        } catch (err) {}
    }

    async changeStatus(id) {
        try {
            const { status, loading, message } = await changeBotStatus(id);
            if (status == "success") {
                toastAlert("success", message, "changeStatus");
                this.getData();
            } else {
                toastAlert("error", message, "changeStatus");
            }
        } catch (err) {}
    }

    async cancelOrder(id) {
        try {
            if (
                !window.confirm(
                    "Are you sure you want to cancel the all open orders ?"
                )
            ) {
                return;
            }

            const { status, loading, message } = await botOrderCancel(id);
            if (status == "success") {
                toastAlert("success", message, "botOrderCancel");
                this.getData();
            } else {
                toastAlert("error", message, "botOrderCancel");
            }
        } catch (err) {}
    }

    openBotModal() {
        this.setState({ tradeBotModal: true });
    }

    closeBotModal() {
        this.setState({ tradeBotModal: false });
    }

    openViewBotModal(record) {
        this.setState({ viewBotModal: true, viewRecord: record });
    }

    closeViewBotModal() {
        this.setState({ viewBotModal: false, viewRecord: {} });
    }

    openBotUrsModal() {
        this.setState({ botUserModal: true });
    }

    closeBotUrsModal() {
        this.setState({ botUserModal: false });
    }

    exportCSV = async () => {

        let { sortOrder, filter, pageSize, offset, totalCount, exportType } = this.state;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let data = {
            timezone,
            sortOrder,
            filter,
            limit: exportType == "current" ? pageSize:totalCount,
            offset: exportType == "current" ? offset:0,
            download: 1
        };

        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[1].children = [<span><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></span>];
            return { extraButtons };
        });

        let { status, result } = await botList(data);

        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[1].children = [
                <span><i className="glyphicon glyphicon-print fa fa-file-excel-o" aria-hidden="true"></i></span>
            ];
            return { extraButtons };
        });

        let records = status ? result: [];
        let separator = ";";
        let headers = [
            "Pair",
            "Created At",
            "Status",
        ];

        let rows = [];
        records.length > 0 && records.map((elt) => rows.push({
            "Pair": elt.pair,
            "Created At": moment(elt.createdAt).format("DD-MM-YYYY HH:mm"),
            "Status": firstLetterCase(elt.status),
        }));

        let csvContent = `${headers.join(separator)}\n${rows.map((row) =>
            headers.map((k) => {
                let cell = row[k] === null || row[k] === undefined ? "" : row[k];

                cell = cell instanceof Date ? cell.toLocaleString():cell.toString().replace(/"/g, '""');

                if (cell.search(/("|,|\n)/g) >= 0) {
                    cell = `"${cell}"`;
                }
                return cell;
            }).join(separator)
        ).join("\n")}`;

        let title = "Bots";
        let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            // In case of IE 10+
            navigator.msSaveBlob(blob, title);
        } else {
            let link = document.createElement("a");
            if (link.download !== undefined) {
                // Browsers that support HTML5 download attribute
                let url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", title);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };

    exportPDF = async () => {

        let { sortOrder, filter, pageSize, offset, totalCount, exportType } = this.state;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let data = {
            timezone,
            sortOrder,
            filter,
            limit: exportType == "current" ? pageSize:totalCount,
            offset: exportType == "current" ? offset:0,
            download: 1
        };

        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[0].children = [<span><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></span>];
            return { extraButtons };
        });


        let { status, result } = await botList(data);

        this.setState((prevState) => {
            let extraButtons = [...prevState.extraButtons];
            extraButtons[0].children = [
                <span><i className="glyphicon glyphicon-print fa fa-file-pdf-o" aria-hidden="true"></i></span>
            ];
            return { extraButtons };
        });

        let records = status ? result: [];

        let unit = "pt";
        let size = "A4"; // Use A1, A2, A3 or A4
        let orientation = "landscape"; // portrait or landscape

        let marginLeft = 40;
        let doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(13);

        let title = "Bots";
        let headers = [[
            "Pair",
            "Created At",
            "Status",
        ]];

        let downloadData = records.length > 0 && records.map((elt) => [
            elt.pair,
            moment(elt.createdAt).format("DD-MM-YYYY HH:mm"),
            firstLetterCase(elt.status),
        ]);

        let content = {
            startY: 50,
            head: headers,
            body: downloadData,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("Bots.pdf");
    }

    render() {
        const { tradeBotModal, pairList, viewRecord, viewBotModal, botUserModal } = this.state;

        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar menuKey={this.props.menuKey} />
                    <TradeBotModal
                        isShow={tradeBotModal}
                        pairList={pairList}
                        refetchPair={this.fetchSpotPair}
                        onHide={this.closeBotModal}
                        refetch={this.getData}
                    />
                    <ViewTradeBot
                        isShow={viewBotModal}
                        record={viewRecord}
                        onHide={this.closeViewBotModal}
                    />

                    <BotUserModal
                        isShow={botUserModal}
                        onHide={this.closeBotUrsModal}
                    />

                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <button
                                onClick={this.openBotModal}
                                className="btn btn-outline-primary float-right mt-3 mr-2"
                            >
                                <FontAwesomeIcon icon={faPlus} />
                                Add Bot
                            </button>
                            <button
                                onClick={this.openBotUrsModal}
                                className="btn btn-outline-primary float-right mt-3 mr-2"
                            >
                                <FontAwesomeIcon icon={faPlus} />
                                Bot User
                            </button>
                            <div className="float-xl-right">
                                Export
                                {["current", "all"].map((v) => (
                                  <Form.Check
                                    inline
                                    type="radio"
                                    name="exportType"
                                    value={v}
                                    key={v}
                                    onChange={(e) => this.setState({ exportType: e.target.value })}
                                    defaultChecked={v == this.state.exportType}
                                    label={firstLetterCase(v)}
                                  />
                                ))}
                            </div>
                            <h3 className="mt-2 text-secondary">Trading Bot</h3>
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                dynamic={true}
                                total_record={this.state.totalCount}
                                loading={this.state.loading}
                                onChange={this.search}
                                extraButtons={this.state.extraButtons}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TradingBot;